var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAsset6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 406.67 108.42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #a37b50;\n      }\n      .skin {\n        fill: #dcba8b;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "disgusted"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M101.67,15.87C45.52,15.87,0,62.15,0,62.15s45.52,46.27,101.67,46.27S203.33,87.7,203.33,62.15,157.82,15.87,101.67,15.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M305,15.87c-56.15,0-101.67,20.72-101.67,46.28S248.85,108.42,305,108.42,406.67,62.15,406.67,62.15,361.15,15.87,305,15.87Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "skin",
    cx: 203.63,
    cy: 38.79,
    rx: 54.65,
    ry: 38.79
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsset6);
export default __webpack_public_path__ + "static/media/Asset 6.e1ec3205.svg";
export { ForwardRef as ReactComponent };